// extracted by mini-css-extract-plugin
module.exports = {"base-card":"_2fY38jm9","compact":"MZF5bWO4","flat":"_2PIQUHwf","flush":"_3yE01qkf"};